import React from 'react'
import colors from '../../../utils/colors'

const ProgressBar = ({progress, total}) => {
  return (
    <div
      className="rounded w-full relative mb-2"
      style={{background: '#ddd', height: '4px'}}
    >
      <div
        className="rounded absolute left-0 top-0 h-full"
        style={{width: `${progress/total*100}%`, background: colors.green}}
      />
    </div>
  )
}

export { ProgressBar }
